/*
 * @Copyright 2020. Institute for Future Intelligence, Inc.
 * @author Charles Xie
 */

export class CloudFileInfo {

  readonly timestamp: number;
  readonly fileName: string;
  readonly owner: string;

  constructor(timestamp: number, fileName: string, owner: string) {
    this.timestamp = timestamp;
    this.fileName = fileName;
    this.owner = owner;
  }

}
